import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_GET_UTC_TIME, PATH_GET_STAFFLYNX_TIME, PATH_GET_STAFFLYNX_CURRENT_WEEK_DATE_RANGE } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'

const datetimeHelper = {
  namespaced: true,
  mutations: {
    updateStatus
  },
  actions: {
    getStaffLynxTime: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_GET_STAFFLYNX_TIME })
        .then(json => json.data)
        .then(time => {
          commit('updateStatus', { status: COMPLETE })
          return time
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    },
    getUTCTime: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_GET_UTC_TIME })
        .then(json => json.data)
        .then(time => {
          commit('updateStatus', { status: COMPLETE })
          return time
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    },
    getStaffLynxCurrentWeekDateRange: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_GET_STAFFLYNX_CURRENT_WEEK_DATE_RANGE })
        .then(json => json.data)
        .then(currentWeekDateRange => {
          commit('updateStatus', { status: COMPLETE })
          return currentWeekDateRange
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    }
  }
}

export default datetimeHelper
